import {
  SETTINGS_PUNCH_LIST_STATUS_TYPE_ERROR,
  SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE_ERROR,
  SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE_SUCCESS,
  SETTINGS_DELETE_PUNCH_LIST_STATUS_TYPE_SUCCESS,
  SETTINGS_GET_PUNCH_LIST_STATUS_TYPE,
  SETTINGS_GET_PUNCH_LIST_STATUS_TYPE_LOADING,
  SETTINGS_PUNCH_LIST_STATUS_TYPE_CLEAR_SNACKBAR,
} from "../constants/types";

const initialState = {
  punchListStatusType: [],
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
};

const punchListStatusTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_PUNCH_LIST_STATUS_TYPE_CLEAR_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
      };
    case SETTINGS_GET_PUNCH_LIST_STATUS_TYPE:
      return {
        ...state,
        ...action.payload,
        showSnackbar: false,
      };
    case SETTINGS_GET_PUNCH_LIST_STATUS_TYPE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SETTINGS_DELETE_PUNCH_LIST_STATUS_TYPE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_PUNCH_LIST_STATUS_TYPE_ERROR:
      return {
        ...state,
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        showSnackbar: true,
      };

    default:
      return state || {};
  }
};

export default punchListStatusTypeReducer;
